import {assertTokenValidForMutation, handleResponse} from "@/services/service-helpers.ts";
import log from '@/lib/logger';

const NBH_ORGANIZATION_DETAILS_ADMIN_BASE_URL = `${import.meta.env.VITE_NBH_URL_ROOT}/api/admin/organization-details`;
const NBH_ORGANIZATION_DETAILS_USER_BASE_URL = `${import.meta.env.VITE_NBH_URL_ROOT}/api/organization-details`;

export interface OrganizationDetails {
    id: string;
    organizationId: string;
    name: string;
    street?: string;
    houseNumber?: string;
    postalCode?: string;
    city?: string;
    phone?: string;
    email?: string;
    website?: string;
    creditorIdentifier?: string;
    creditorIban?: string;
    creditorBic?: string;
    hasCompleteAddress: boolean;
    hasSepaConfiguration: boolean;
    createdAt: string;
    createdBy: string;
    updatedAt?: string;
    updatedBy?: string;
}

export interface CreateOrganizationDetailsDto {
    name: string;
    street?: string;
    houseNumber?: string;
    postalCode?: string;
    city?: string;
    phone?: string;
    email?: string;
    website?: string;
    creditorIdentifier?: string;
    creditorIban?: string;
    creditorBic?: string;
}

export interface UpdateOrganizationDetailsDto {
    name: string;
    street?: string;
    houseNumber?: string;
    postalCode?: string;
    city?: string;
    phone?: string;
    email?: string;
    website?: string;
    creditorIdentifier?: string;
    creditorIban?: string;
    creditorBic?: string;
}

export async function getOrganizationDetails(token: string | null): Promise<OrganizationDetails | null | void> {
    if (!token) {
        log.error("No token provided for organization details retrieval.");
        return Promise.reject("No token provided");
    }

    const response = await fetch(NBH_ORGANIZATION_DETAILS_USER_BASE_URL, {
        method: 'GET',
        headers: new Headers({
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        })
    });

    if (response.status === 204) {
        return null;
    }

    return handleResponse<OrganizationDetails>(response);
}

export async function createOrganizationDetails(
    token: string | null,
    dto: CreateOrganizationDetailsDto
): Promise<OrganizationDetails | void> {
    if (!token) {
        log.error("No token provided for organization details creation.");
        return Promise.reject("No token provided");
    }
    assertTokenValidForMutation()

    const response = await fetch(NBH_ORGANIZATION_DETAILS_ADMIN_BASE_URL, {
        method: 'POST',
        headers: new Headers({
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        }),
        body: JSON.stringify(dto)
    });

    return handleResponse<OrganizationDetails>(response);
}

export async function updateOrganizationDetails(
    token: string | null,
    dto: UpdateOrganizationDetailsDto
): Promise<OrganizationDetails | void> {
    if (!token) {
        log.error("No token provided for organization details update.");
        return Promise.reject("No token provided");
    }
    assertTokenValidForMutation()

    const response = await fetch(NBH_ORGANIZATION_DETAILS_ADMIN_BASE_URL, {
        method: 'PUT',
        headers: new Headers({
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        }),
        body: JSON.stringify(dto)
    });

    return handleResponse<OrganizationDetails>(response);
}